import React, { useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { DashboardLayout } from "components/layout/components/DashboardLayout";
import RecruitmentFeedbackFlow from "../components/RecruitmentFeedbackFlow";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { openNotification } from "utils/notification";
import { IFeedbackJob } from "../types";
import { useSavePendingJobsFeedback } from "../hooks/useSavePendingJobsFeedback";

const FeedbackScreen = () => {
  const { token, userInfo } = useGetUserInfo();
  const { jobId } = useParams<{ jobId?: string }>();
  const navigate = useNavigate();
  const { state } = useLocation();
  const selectedJob = (state.job || []) as IFeedbackJob[];
  const { mutate: savePendingJobsFeedback } = useSavePendingJobsFeedback();

  const handleFeedbackSubmitted = useCallback((payload: string[]) => {
    // call api to submit feedback
    
    savePendingJobsFeedback({
      jobId: jobId,
      talents: payload,
      token
    }, {
      onError: (err: any) => {
        let errorTitle = "Error";
        let errorDescription = "An error occurred, please try again.";

        if (err.response && err.response.data && err.response.data.error) {
          errorTitle = "Error: " + err.response.data.error;
          errorDescription =
            err.response.data.description || "Please try again.";
        }

        openNotification({
          title: errorTitle,
          state: "error",
          description: errorDescription,
          duration: 6,
        });
      },
      onSuccess: (res: any) => {
        openNotification({
          title: "Feedback Submitted",
          description: "Thank you for your feedback!",
          state: "success",
          duration: 4.5,
        });
        navigate("/");
      },
    });
  }, [navigate]);


    return (
      <DashboardLayout>
        {selectedJob ? (
          <RecruitmentFeedbackFlow
            job={selectedJob}
            isLoading={false}
            onExit={() => navigate('/dashboard/skipRecruitmentFeedback')}
            onCompleted={handleFeedbackSubmitted}
          />
        ) : (
          <div className="flex items-center justify-center h-64">
            <div className="text-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
              <p className="mt-3 text-gray-600">Loading job details...</p>
            </div>
          </div>
        )}
      </DashboardLayout>
    );
}

export default FeedbackScreen;
